export interface BreadcrumbItem {
  label: string;
  href?: string;
}

export function getBreadcrumbTrail(pathname: string): BreadcrumbItem[] {
  // Breadcrumb logic for nested index pages ("Errors", "Samples", "Authorization flows")
  if (
    pathname.startsWith('/verify/reference/errors/danish-mitid') ||
    pathname.startsWith('/verify/reference/errors/general')
  ) {
    return [
      { label: 'Reference', href: '/verify/reference' },
      { label: 'Errors', href: '/verify/reference/errors' },
    ];
  } else if (pathname.startsWith('/verify/reference/samples/custom-ui-samples')) {
    return [
      { label: 'Reference', href: '/verify/reference' },
      { label: 'Samples', href: '/verify/reference/samples' },
    ];
  } else if (
    pathname.startsWith('/verify/reference/authorization-flows/authorization-code-flow') ||
    pathname.startsWith('/verify/reference/authorization-flows/implicit-flow') ||
    pathname.startsWith('/verify/reference/authorization-flows/pkce') ||
    pathname.startsWith('/verify/reference/authorization-flows/ciba') ||
    pathname.startsWith('/verify/reference/authorization-flows/headless')
  ) {
    return [{ label: 'Reference', href: '/verify/reference' }];
  }
  return [];
}
